import { ReactNode, useCallback } from 'react';
import { useGlobalComponentsContext } from 'src/contexts/GlobalComponentsContext';
import {
  DialogCentered,
  DialogCenteredProps,
} from 'src/components/DialogCentered';
import { DialogBodyStandard } from 'src/components/dialog/DialogBodyStandard';
import { useRedirectCallback } from './useRedirectCallback';
import { WizardOptions } from './wizard/createUseWizard';

export type OpenDialogSettings = {
  title: string;
  description?: string | ReactNode;
  children?: ReactNode;
  showClose?: boolean;
} & Omit<DialogCenteredProps, 'open'>;

export function useDialog(
  id: string,
  options: WizardOptions = { closeOnRouteChange: true },
) {
  const { union, remove } = useGlobalComponentsContext();
  const close = useCallback(() => {
    remove(id);
  }, [id, remove]);

  useRedirectCallback(options.closeOnRouteChange ? close : undefined);
  return {
    open: ({
      title,
      description,
      children,
      onClose,
      showClose = true,
      ...props
    }: OpenDialogSettings) => {
      union(
        id,
        <DialogCentered
          open={true}
          {...props}
          onClose={() => {
            remove(id);
            if (!!onClose) {
              onClose();
            }
          }}
          showCloseIcon={showClose}
        >
          <DialogBodyStandard title={title} description={description}>
            {children}
          </DialogBodyStandard>
        </DialogCentered>,
      );
    },
    close,
  };
}
